module.exports = __webpack_public_path__ + "SamsungOne-600C.946f0c4d829aed6cde91.ttf";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/SamsungOne-600C.ttf
// module id = ../../../../../src/assets/layout/fonts/SamsungOne-600C.ttf
// module chunks = styles